import React, { useEffect, useState } from 'react';
import headerBrandLogo from '../../static/images/essaar-header-logo.png';
import { isNativeApp } from '../../utils/nativeApp.js';

/**
 * The header slot has a real width and height. object-contain scales the whole
 * mark inside that slot so phones and iPads never clip the wordmark.
 */
const LOGO_IMG_CLASS = 'block h-full w-full object-contain object-left';

export default function AppBrandLogo({ companyLogo, variant = 'header', className = '', alt = 'Company logo', onClick }) {
  const frameClass = className || 'block h-full w-full min-w-0';
  const wrap = (node) => (
    onClick ? (
      <button
        type="button"
        onClick={onClick}
        className={`${frameClass} cursor-pointer bg-transparent border-0 p-0 leading-none`}
        title="Refresh"
        aria-label="Refresh page"
      >
        {node}
      </button>
    ) : (
      <span className={frameClass}>{node}</span>
    )
  );
  const [companyFailed, setCompanyFailed] = useState(false);
  // Keep last good company logo so remount/reload does not flash the default brand
  const [stableCompanyLogo, setStableCompanyLogo] = useState(companyLogo || null);
  const nativeApp = isNativeApp();

  useEffect(() => {
    if (companyLogo) {
      setCompanyFailed(false);
      setStableCompanyLogo(companyLogo);
    }
  }, [companyLogo]);

  const activeCompanyLogo = companyLogo || stableCompanyLogo;
  const showCompany = activeCompanyLogo && !companyFailed;

  if (showCompany) {
    return wrap(
      <img
        src={activeCompanyLogo}
        alt={alt}
        className={LOGO_IMG_CLASS}
        decoding="async"
        onError={() => setCompanyFailed(true)}
      />
    );
  }

  const brand = (
    <img
      src={headerBrandLogo}
      alt="Essaar"
      className={LOGO_IMG_CLASS}
      decoding="async"
    />
  );

  if (variant === 'header' || nativeApp) {
    return wrap(brand);
  }

  return brand;
}
